export const WAKELOOP_CLAUDE_ALLOWED_TOOLS = [
    "Bash(wakeloop)",
    "Bash(wakeloop *)",
    "Bash(wakeloop-dev)",
    "Bash(wakeloop-dev *)",
    "Bash(wakeloop-canary)",
    "Bash(wakeloop-canary *)",
];
const CLAUDE_PERMISSION_MODE_BY_POLICY = {
    "claude-code:default": "default",
    "claude-code:acceptEdits": "acceptEdits",
    "claude-code:plan": "plan",
    "claude-code:auto": "auto",
    "claude-code:dontAsk": "dontAsk",
    "claude-code:bypassPermissions": "bypassPermissions",
};
export function resolveClaudeAgentControllerPermissionMode(value) {
    switch (value) {
        case "claude-code:acceptEdits":
        case "claude-code:plan":
        case "claude-code:auto":
        case "claude-code:dontAsk":
        case "claude-code:bypassPermissions":
            return value;
        default:
            return "claude-code:default";
    }
}
export function resolveClaudePermissionMode(input) {
    if (input.executionMode === "repair") {
        return "plan";
    }
    return CLAUDE_PERMISSION_MODE_BY_POLICY[resolveClaudeAgentControllerPermissionMode(input.agentControllerPermissionMode)];
}
